import intl from 'react-intl-universal';
import { useEffect, useMemo, useState } from 'react';
import { message } from 'antd';
import { DynamicForm, Modal } from '@/components';
import { ProFormColumnsType } from '@ant-design/pro-components';
import { getQueues, getClientsByQno } from '@/api/softPhone';

interface Props {
    show: boolean;
    onSave?: (params) => void;
    onClose?: () => void;
}

const ivrName = intl.get('转接队列');

// import style from '../index.less';
const ChangeQueue: React.FC<Props> = ({ show = false, onSave, onClose }) => {
    const [queueList, setQueueList] = useState([]);

    useEffect(() => {
        if (show) {
            getQueues().then((res) => {
                const list = res.data?.map((item) => {
                    return {
                        label: item.name,
                        value: item.qno,
                        isLeaf: false,
                    };
                });
                console.log('-=-=-=', list);
                setQueueList(list);
            });
        }
    }, [show]);

    const columns: ProFormColumnsType[] = useMemo(
        () => [
            {
                dataIndex: 'cno',
                title: intl.get('员工'),
                valueType: 'cascader',
                fieldProps: {
                    options: queueList,
                    showSearch: false,
                    loadData: (options) => {
                        console.log('onLoad', options);
                        const targetOption = options[options.length - 1];

                        getClientsByQno(targetOption.value).then((res) => {
                            targetOption.children =
                                res.data?.map((item) => {
                                    return {
                                        label: `${item.name}（${
                                            item.agentStatusDetails.length
                                                ? item.agentStatusDetails[0]
                                                : intl.get('空闲')
                                        }）`,

                                        value: item.cno,
                                        isLeaf: true,
                                        disabled: item.agentStatusDetails.length
                                            ? item.agentStatusDetails[0] !==
                                              intl.get('空闲')
                                            : false,
                                    };
                                }) || [];

                            if (res.data.length === 0) {
                                message.warning(intl.get('该队列下暂无坐席'));
                            }

                            setQueueList([...queueList]);
                        });
                    },
                },
                formItemProps: {
                    rules: [
                        {
                            required: true,
                            message: intl.get('请选择员工'),
                        },
                    ],
                },
            },
        ],

        [queueList],
    );

    const onFinish = async (values) => {
        onSave?.({
            ...values,
            cno: values.cno[values.cno.length - 1],
            ivrName,
        });
    };

    return (
        <Modal
            title={intl.get('转员工')}
            open={show}
            // onOk={handleOk}
            onCancel={onClose}
            footer={null}
            destroyOnClose={true}
        >
            <DynamicForm
                className="modalForm"
                labelCol={{ span: 6 }}
                columns={columns}
                onFinish={onFinish}
                initialValues={{
                    bindType: 2,
                    loginStatus: 1,
                }}
                submitter={{
                    searchConfig: {
                        resetText: intl.get('取消'),
                        submitText: intl.get('确认'),
                    },
                    onReset: () => {
                        onClose?.();
                    },
                }}
            />
        </Modal>
    );
};

export default ChangeQueue;
